import { IQueries, IUnresolvedQuery } from 'src/types/SummaryDashboard';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  DialogActions,
  DialogContent,
  LinearProgress,
  Typography,
  CircularProgress
} from '@mui/material';
import question from './question.svg';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { archLevel } from 'src/data/config';
import { useLazyGetQueriesDashboardDataQuery } from 'src/services/SummaryDashboard';
import { setMessage } from 'src/store/Message';
import { PopupComponent } from 'src/components/common/PopupComponent';

const QueriesWidget = (props: { queriesObjStatic: IQueries }) => {
  const { queriesObjStatic } = props;
  const [queriesDataObj, setQueriesDataObj] = useState(queriesObjStatic);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { getDateTimeDiffWithCurrentUTC } = usePreferedDateFormat();

  const dispatchApp = useAppDispatch();
  const { selectedApp } = useSelectedAppInfo();
  const studyId = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const appName = archLevel == 'site' ? process.env.REACT_APP_NAME_TEMP : process.env.REACT_APP_NAME;
  const [isWidgetDataLoading, setIsWidgetDataLoading] = useState(false);

  const [getQueriesDashboardData, { error: queriesDashboardError, isError: queriesDashboardIsError }] =
    useLazyGetQueriesDashboardDataQuery();

  const getqueriesWidgetData = async () => {
    setIsWidgetDataLoading(true);
    const queriesResponse: any = await getQueriesDashboardData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: appName,
      application_section: selectedApp
    });
    if (queriesResponse.isSuccess) {
      setQueriesDataObj(queriesResponse.data);
    } else if (queriesResponse.isError) {
      setQueriesDataObj({} as IQueries);
    }
    setIsWidgetDataLoading(false);
  };

  useEffect(() => {
    setQueriesDataObj(queriesObjStatic);
    getqueriesWidgetData();
  }, [selectedSite]);

  useEffect(() => {
    if (queriesDashboardIsError) {
      setQueriesDataObj({} as IQueries);
      const err: any = queriesDashboardError;
      if (err?.status == 500) {
        dispatchApp(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatchApp(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      }
    }
  }, [queriesDashboardIsError]);
  const showQueriesWidget = (queriesObj: IQueries, isInPopup = false) => {
    return (
      <>
        {queriesObj && (
          <Container style={{ paddingLeft: '5px', paddingRight: '16px' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6" fontWeight={700}>
                {queriesObj.name}
                {isWidgetDataLoading && (
                  <CircularProgress size="1.5rem" style={{ position: 'relative', left: '5px' }} />
                )}
              </Typography>
              <Typography variant="body1">{`${queriesObj?.percentage}%`}</Typography>
            </Box>
            <Box mt={2}>
              <LinearProgress
                color="success"
                variant="determinate"
                value={queriesObj.percentage}
                style={{ height: 8, borderRadius: 5, backgroundColor: '#efefef' }}
              />
            </Box>
            {queriesObj?.unresolved_queries?.length ? (
              queriesObj?.unresolved_queries?.map(
                (query: IUnresolvedQuery, index: number) =>
                  (isInPopup || index < 2) && (
                    <Box key={query.id} mt={2}>
                      <Grid container spacing={2} justifyContent="space-between">
                        <Grid item xs={1} style={{ display: 'flex', alignItems: 'center', paddingLeft: '30px' }}>
                          <img src={question} alt="question" style={{ marginRight: '2.5px' }} />
                        </Grid>
                        <Grid item xs={8} style={{ paddingLeft: '20px' }}>
                          <Typography variant="h6" style={{ color: '#243F81' }}>
                            {query.module}
                          </Typography>
                          <Typography variant="body1">{query.query_message}</Typography>
                        </Grid>
                        <Grid item xs={3} style={{ textAlign: 'right', paddingLeft: '0px' }}>
                          {`${getDateTimeDiffWithCurrentUTC(query.updated_on)} ago`}
                        </Grid>
                      </Grid>
                    </Box>
                  )
              )
            ) : (
              <Box mt={2} mb={2}>
                <Alert severity="info">No Queries Raised</Alert>
              </Box>
            )}
          </Container>
        )}
      </>
    );
  };
  return (
    <>
      {showQueriesWidget(queriesDataObj)}
      {queriesDataObj?.unresolved_queries?.length > 0 && (
        <Button
          onClick={() => setIsPopupOpen(true)}
          style={{ display: 'flex', alignItems: 'flex-end', marginLeft: 'auto', marginRight: '5px' }}
        >
          View More
        </Button>
      )}
      <PopupComponent
        aria-labelledby="customized-dialog-title"
        open={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      >
        <DialogContent style={{ width: '600px' }}>{showQueriesWidget(queriesDataObj, true)}</DialogContent>
        <DialogActions>
          <Button onClick={() => setIsPopupOpen(false)}>Close</Button>
        </DialogActions>
      </PopupComponent>
    </>
  );
};

export default QueriesWidget;
